document.addEventListener("DOMContentLoaded", () => {
  const tabsContainer = document.querySelector(".responsive-tabs");
  
  // Check if the .responsive-tabs element exists
  if (!tabsContainer) {
    console.log("No element with class 'responsive-tabs' found. Skipping tab setup.");
    return;
  }

  const titles = tabsContainer.querySelectorAll(".tabtitle");
  const contents = tabsContainer.querySelectorAll(".tabcontent");

  // Create a container for tab buttons
  const tabButtonsContainer = document.createElement("div");
  tabButtonsContainer.classList.add("tab-buttons");

  // Loop through titles to create buttons
  titles.forEach((title, index) => {
    const button = document.createElement("button");
    button.textContent = title.textContent;
    button.addEventListener("click", () => {
      // Remove active class from all
      document.querySelectorAll(".tab-buttons button").forEach(btn => btn.classList.remove("active"));
      contents.forEach(content => content.classList.remove("active"));

      // Add active class to clicked button and corresponding content
      button.classList.add("active");
      contents[index].classList.add("active");
    });

    // Add first tab as active by default
    if (index === 0) {
      button.classList.add("active");
      contents[index].classList.add("active");
    }

    tabButtonsContainer.appendChild(button);
  });

  // Insert tab buttons container at the top
  tabsContainer.insertBefore(tabButtonsContainer, titles[0]);

  // Remove original h2 elements (tab titles)
  titles.forEach(title => title.remove());
});